import * as Sentry from '@sentry/browser';
import { getTldPerEnv } from '../config/infra.esm.js';
import { Env } from './infra.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function setupSentry(sentryOptions, user) {
    if (!sentryOptions.enabled) return;
    Sentry.init(_object_spread({
        attachStacktrace: true,
        allowUrls: [
            new RegExp(getTldPerEnv(Env.Staging)),
            new RegExp(getTldPerEnv(Env.Production))
        ]
    }, sentryOptions));
    if (user) {
        Sentry.setUser({
            id: user.userId
        });
    }
    if (sentryOptions.environment !== Env.Production) {
        window.sentry = Sentry;
    }
}
/**
 * @deprecated Use `MonitoringProvider` instead
 */ function reportFci(// fci => failed client interaction
error) {
    var tags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    Sentry.captureException(error, {
        tags: _object_spread_props(_object_spread({}, tags), {
            fci: true
        }),
        extra: extras
    });
}

export { reportFci, setupSentry };
